// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__17QMP","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__26Rrp"};